import { CompanyDetailOutputAlertData } from './company-detail-output-alert-data.model';
import { CompanyDetailOutputMapData } from './company-detail-output-map-data.model';


export class CompanyDetailOutputData implements ICompanyDetailOutputData {
    /** The Reference id of the tbl_company_detail table */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The company short name with 255 character limit */
    short_name!: string;
    /** The alert type must be one of "All" or "Select" */
    alert_type!: string;
    /** The street 1 with 255 character limit */
    street_1!: string;
    /** The street 2 with 255 character limit */
    street_2!: string;
    /** The Reference id of the tbl_city table */
    city_id!: number;
    /** The ZIP code with 6 character limit */
    zip_code!: string;
    /** The internet address with 255 character limit */
    internet_address!: string;
    /** The contact person with 255 character limit */
    contact_person!: string;
    /** The email id of user with 320 character limit */
    email!: string;
    /** The help desk number with 13 character limit */
    help_desk_number!: string;
    /** The mobile number with 10 character limit */
    mobile_number!: string;
    /** The whatsapp number with 10 character limit */
    whatsapp_number!: string;
    /** The fax number with 20 character limit */
    fax_number!: string;
    /** The over ride poi on location must be one of 0 or 1 */
    override_poi_on_location!: number;
    /** The Reference id of the tbl_storage_days table */
    storage_days_id!: number;
    /** The show support detail must be one of 0 or 1 */
    show_support_detail!: number;
    /** The driver consideration based must be one of "RFID" or "STEP INOUT" */
    driver_consideration_based_on!: string;
    /** The company logo with 2048 character limit */
    company_logo!: string;
    /** Manage status of company detail. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated creating time of tbl_company_detail item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_company_detail item add or update */
    updating_date!: any;
    /** The storage days name */
    storage_days_name!: string;
    /** The city name with 255 character limit */
    city_name!: string;
    /** The Reference id of the tbl_state table */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The Reference id of the tbl_country table */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;
    alert!: CompanyDetailOutputAlertData[];
    map!: CompanyDetailOutputMapData[];

    constructor(data?: ICompanyDetailOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.short_name = _data["short_name"];
            this.alert_type = _data["alert_type"];
            this.street_1 = _data["street_1"];
            this.street_2 = _data["street_2"];
            this.city_id = _data["city_id"];
            this.zip_code = _data["zip_code"];
            this.internet_address = _data["internet_address"];
            this.contact_person = _data["contact_person"];
            this.email = _data["email"];
            this.help_desk_number = _data["help_desk_number"];
            this.mobile_number = _data["mobile_number"];
            this.whatsapp_number = _data["whatsapp_number"];
            this.fax_number = _data["fax_number"];
            this.override_poi_on_location = _data["override_poi_on_location"];
            this.storage_days_id = _data["storage_days_id"];
            this.show_support_detail = _data["show_support_detail"];
            this.driver_consideration_based_on = _data["driver_consideration_based_on"];
            this.company_logo = _data["company_logo"];
            this.status = _data["status"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
            this.storage_days_name = _data["storage_days_name"];
            this.city_name = _data["city_name"];
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
            if (Array.isArray(_data["alert"])) {
                this.alert = [] as any;
                for (let item of _data["alert"])
                    this.alert!.push(CompanyDetailOutputAlertData.fromJS(item));
            }
            if (Array.isArray(_data["map"])) {
                this.map = [] as any;
                for (let item of _data["map"])
                    this.map!.push(CompanyDetailOutputMapData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyDetailOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["short_name"] = this.short_name;
        data["alert_type"] = this.alert_type;
        data["street_1"] = this.street_1;
        data["street_2"] = this.street_2;
        data["city_id"] = this.city_id;
        data["zip_code"] = this.zip_code;
        data["internet_address"] = this.internet_address;
        data["contact_person"] = this.contact_person;
        data["email"] = this.email;
        data["help_desk_number"] = this.help_desk_number;
        data["mobile_number"] = this.mobile_number;
        data["whatsapp_number"] = this.whatsapp_number;
        data["fax_number"] = this.fax_number;
        data["override_poi_on_location"] = this.override_poi_on_location;
        data["storage_days_id"] = this.storage_days_id;
        data["show_support_detail"] = this.show_support_detail;
        data["driver_consideration_based_on"] = this.driver_consideration_based_on;
        data["company_logo"] = this.company_logo;
        data["status"] = this.status;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        data["storage_days_name"] = this.storage_days_name;
        data["city_name"] = this.city_name;
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        if (Array.isArray(this.alert)) {
            data["alert"] = [];
            for (let item of this.alert)
                data["alert"].push(item.toJSON());
        }
        if (Array.isArray(this.map)) {
            data["map"] = [];
            for (let item of this.map)
                data["map"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICompanyDetailOutputData {
    /** The Reference id of the tbl_company_detail table */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The company short name with 255 character limit */
    short_name: string;
    /** The alert type must be one of "All" or "Select" */
    alert_type: string;
    /** The street 1 with 255 character limit */
    street_1: string;
    /** The street 2 with 255 character limit */
    street_2: string;
    /** The Reference id of the tbl_city table */
    city_id: number;
    /** The ZIP code with 6 character limit */
    zip_code: string;
    /** The internet address with 255 character limit */
    internet_address: string;
    /** The contact person with 255 character limit */
    contact_person: string;
    /** The email id of user with 320 character limit */
    email: string;
    /** The help desk number with 13 character limit */
    help_desk_number: string;
    /** The mobile number with 10 character limit */
    mobile_number: string;
    /** The whatsapp number with 10 character limit */
    whatsapp_number: string;
    /** The fax number with 20 character limit */
    fax_number: string;
    /** The over ride poi on location must be one of 0 or 1 */
    override_poi_on_location: number;
    /** The Reference id of the tbl_storage_days table */
    storage_days_id: number;
    /** The show support detail must be one of 0 or 1 */
    show_support_detail: number;
    /** The driver consideration based must be one of "RFID" or "STEP INOUT" */
    driver_consideration_based_on: string;
    /** The company logo with 2048 character limit */
    company_logo: string;
    /** Manage status of company detail. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated creating time of tbl_company_detail item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_company_detail item add or update */
    updating_date: any;
    /** The storage days name */
    storage_days_name: string;
    /** The city name with 255 character limit */
    city_name: string;
    /** The Reference id of the tbl_state table */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** The Reference id of the tbl_country table */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
    alert: CompanyDetailOutputAlertData[];
    map: CompanyDetailOutputMapData[];
}

